import React from 'react';
import './LoadingScreen.css';

const LoadingScreen = () => {
    return (
        <div className="loading-screen">
            <div className="loading-content">
                {/* <div className="spinner"> */}
                    <span className="loader_pro"></span>
                {/* </div> */}
                <p className="loading-text">Cargando...</p>
            </div>
        </div>
    );
};

export default LoadingScreen;
